import { useEffect, useRef } from "react";

export function useInterval(callback: VoidFunction, delay: number) {
  const savedCallback = useRef<VoidFunction>();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current && savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
